import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { ModalStyles } from './styles/Modal.styles';
import { sendDataToParent } from '../../Map/base/functions/sendDataToParent';
import { useDispatch, useSelector } from 'react-redux';
import { isModalOpenState, modalBodyState } from '../../../app/redux/retrievers/retrievers';
import { setIsModalOpen } from '../../../app/redux/slices/isModalOpenSlice';
import '../../../fonts/Kohinoor-Regular.TTF';

const Modal = () => {
    const dispatch = useDispatch();
    const modalBody = useSelector(modalBodyState);
    const isModalOpen = useSelector(isModalOpenState);

    const [receivedButtonElement, setReceivedButtonElement] = useState<any>();
    const [closeButtonElement, setCloseButtonElement] = useState<any>();
    // const modalButtonElement = document.getElementById('modal-button');

    const handleReceivedButtonClick = () => {
        sendDataToParent({ type: 'modal-button-clicked' });
        sendDataToParent({ type: 'modal-closed' });
        // dispatch(setIsModalOpen(false));
    };

    const handleCloseButtonClicked = () => {
        sendDataToParent({ type: 'modal-closed' });
        dispatch(setIsModalOpen(false));
    };

    window.addEventListener('click', function (e) {
        e.stopPropagation();
        document.getElementById('modal') &&
            //@ts-ignore
            !document.getElementById('modal').contains(e.target) &&
            dispatch(setIsModalOpen(false));
    });

    receivedButtonElement && receivedButtonElement.addEventListener('click', handleReceivedButtonClick);
    closeButtonElement && closeButtonElement.addEventListener('click', handleCloseButtonClicked);

    useEffect(() => {
        setReceivedButtonElement(document.getElementById('received-button'));
        setCloseButtonElement(document.getElementById('close-button'));
        !isModalOpen && sendDataToParent({ type: 'modal-closed' });
    }, [modalBody, isModalOpen]);

    return (
        <div id="modal" style={ModalStyles(isModalOpen).Modal}>
            {parse(modalBody)}
        </div>
    );
};

export default Modal;
